import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import {
  fetchBrandingError,
  fetchBrandingSuccess,
  fetchTenantDomainsError,
  fetchTenantDomainsSuccess,
  saveBrandingError,
  saveBrandingSuccess,
} from './actions'
import { FETCH_BRANDING_ASYNC, FETCH_TENANT_DOMAINS_ASYNC, SAVE_BRANDING_ASYNC } from './constants'

const getCompanyId = (state$) => state$.value.partnerOptions?.selectedCompany?.value || ''

const fetchBrandingEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_BRANDING_ASYNC.INITIATE),
    mergeMap(() => {
      const companyId = getCompanyId(state$)
      return api.settings.getEmailEncryptionBranding(companyId).pipe(
        map((response) => fetchBrandingSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchBrandingError, error)))
      )
    })
  )

const saveBrandingEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SAVE_BRANDING_ASYNC.INITIATE),
    mergeMap(({ payload }) => {
      const companyId = getCompanyId(state$)
      return api.settings.updateEmailEncryptionBranding(companyId, payload).pipe(
        map((response) => saveBrandingSuccess(response)),
        catchError((error) => of(epicsErrorHandler(saveBrandingError, error)))
      )
    })
  )

const fetchTenantDomainsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_TENANT_DOMAINS_ASYNC.INITIATE),
    mergeMap(() => {
      const companyId = getCompanyId(state$)
      return api.settings.getGeneralSettings(companyId).pipe(
        map((response) =>
          fetchTenantDomainsSuccess(
            (response?.allowedDomains || '')
              .split(',')
              .map((domain) => domain.trim().toLowerCase())
              .filter(Boolean)
          )
        ),
        catchError((error) => of(epicsErrorHandler(fetchTenantDomainsError, error)))
      )
    })
  )

export default combineEpics(fetchBrandingEpic, saveBrandingEpic, fetchTenantDomainsEpic)
